import {callbacksHandler} from "on-location-changed/build/callbacks-handler"
import CommandsPool from "@kaspernj/api-maker/build/commands-pool"

const updateCurrentUrl = () => {
  if (!globalThis.location) return

  const commandsPool = CommandsPool.current()

  if (!commandsPool.globalRequestData) commandsPool.globalRequestData = {}

  commandsPool.globalRequestData.url = globalThis.location.href
  commandsPool.globalRequestData.url_referer = globalThis.document?.referrer || null
}

updateCurrentUrl()
callbacksHandler.onLocationChanged(updateCurrentUrl)
